import { h, clear } from '../utils/dom.js';

export function renderNavigator(container, state, actions) {
	clear(container);

	const { index, nav, book: currentBook, chapter: currentChapter } = state;

	if (!index) {
		container.appendChild(h('p', { class: 'blb-search-hint' }, state.i18n.loading));
		return;
	}

	const tabs = h('div', { class: 'blb-testament-tabs' }, [
		h(
			'button',
			{
				class: 'blb-testament-tab' + (nav.testament === 'OT' ? ' blb-active' : ''),
				onClick: () => actions.setNavTestament('OT'),
			},
			`📜 ${state.i18n.oldTestament}`
		),
		h(
			'button',
			{
				class: 'blb-testament-tab' + (nav.testament === 'NT' ? ' blb-active' : ''),
				onClick: () => actions.setNavTestament('NT'),
			},
			`✝️ ${state.i18n.newTestament}`
		),
	]);

	container.appendChild(tabs);

	if (nav.view === 'chapters' && nav.bookId) {
		const book = index.books.find((b) => b.id === nav.bookId);

		container.appendChild(
			h('div', { class: 'blb-breadcrumb' }, [
				h('button', { onClick: () => actions.setNavView('books') }, '← Books'),
				h('span', null, `/ ${book ? book.name : ''}`),
			])
		);

		const grid = h('div', { class: 'blb-chapter-grid' });
		if (book) {
			const available = (book.available && book.available[state.translation]) || [];
			for (let c = 1; c <= book.chapters; c++) {
				const isAvailable = available.includes(c);
				const isActive = book.id === currentBook && c === currentChapter;
				grid.appendChild(
					h(
						'button',
						{
							class:
								'blb-chapter-btn' +
								(isActive ? ' blb-active' : '') +
								(isAvailable ? ' blb-chapter-available' : ''),
							onClick: () => actions.selectChapter(book.id, c),
							title: isAvailable ? 'Available in demo dataset' : undefined,
						},
						String(c)
					)
				);
			}
		}
		container.appendChild(grid);
		return;
	}

	const books = index.books.filter((b) => b.testament === nav.testament);
	const grid = h('div', { class: 'blb-book-grid' });

	books.forEach((book) => {
		const isActive = book.id === currentBook;
		grid.appendChild(
			h(
				'button',
				{
					class:
						'blb-book-btn blb-testament-' +
						book.testament.toLowerCase() +
						(isActive ? ' blb-active' : ''),
					onClick: () => actions.openBookChapters(book.id),
				},
				[
					h('span', { class: 'blb-book-name' }, book.name),
					h(
						'span',
						{ class: 'blb-book-meta' },
						`${book.chapters} ch · ${((book.available && book.available[state.translation]) || []).length} loaded`
					),
				]
			)
		);
	});

	container.appendChild(grid);
}
